module.exports = __webpack_public_path__ + "static/media/backButton.229d3695.svg";